import * as angular from 'angular';
import * as moment from 'moment';

import { IMenuSchedule } from '../../models';
import { ScheduleService } from '../../schedule.service';

class MenuScheduleRenderController {
    public static $inject = ['$scope', '$translate', 'scheduleService'];

    public item: IMenuSchedule;

    private dateFormat = 'DD MMM YYYY';
    private timeFormat = 'hh:mm A';
    private rendered: string = '';

    constructor(
        $scope: ng.IScope,
        private $translate: angular.translate.ITranslateService,
        private scheduleService: ScheduleService
    ) {
        $scope.$watch(
            'vm.item',
            (changes: any) => {
                if (!changes) {
                    this.item = {
                        days: {
                            friday: false,
                            monday: false,
                            saturday: false,
                            sunday: false,
                            thursday: false,
                            tuesday: false,
                            wednesday: false
                        },
                        startDate: null,
                        endDate: null,
                        startTime: null,
                        endTime: null
                    } as IMenuSchedule;
                    this.rendered = '';
                    return;
                }

                const dates = this.renderDate();
                const time = this.renderTime();
                this.rendered = `${time}${time ? '<br />' : ''}${dates}`;
            },
            true
        );
    }

    private renderTime() {
        const days = this.scheduleService.renderDaysOfWeek(
            this.scheduleService.packDaysOfWeek(this.item.days).toString()
        );
        const startTime = moment(this.item.startTime);
        const endTime = moment(this.item.endTime);

        if (!startTime.isValid() && !endTime.isValid()) {
            return days ? (this.$translate.instant('active') + ' ' + days) : '';
        }

        return this.$translate.instant(endTime.isValid() ? 'active_on_between' : 'active_on_from', {
            days,
            start: startTime.format(this.timeFormat),
            end: endTime.format(this.timeFormat)
        });
    }

    private renderDate() {
        const startDate = moment(this.item.startDate);
        const endDate = moment(this.item.endDate);

        if (startDate.isValid() && endDate.isValid()) {
            return this.$translate.instant('from_until', {
                start: startDate.format(this.dateFormat),
                end: endDate.format(this.dateFormat)
            });
        }

        if (startDate.isValid()) {
            return this.$translate.instant('from', {
                start: startDate.format(this.dateFormat)
            });
        }

        if (endDate.isValid()) {
            return this.$translate.instant('until', {
                end: endDate.format(this.dateFormat)
            });
        }

        return '';
    }
}

angular.module('naut').component('menuScheduleRender', {
    template: require('./menu.schedule.render.html'),
    controller: MenuScheduleRenderController,
    controllerAs: 'vm',
    bindings: {
        item: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/menus/components/menu-schedule-render/menu.schedule.render.component.ts